import { language as lan_storeStatusIcon } from "./store-status-icon";

let language = {
    // 店铺状态、店铺连接状态
    ...lan_storeStatusIcon,

    STORE_PRODUCT_FILTER_STORE_DES: "选择一个商店来查看、编辑、添加或删除产品。",
    STORE_PRODUCT_FILTER_STORE_TITLE: "商店:",
    STORE_PRODUCT_FILTER_PRODUCT_SEARCH_TIP:"不支持特殊字符"
};

export { language }
